import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import Title from "../general/title"
import FullTable from "components/FullTable"
import numeral from "numeral"
import helpers from "helpers/helpers"
import moment from "moment"
import { getPayload, updateDates } from "actions"

const MUD = (props) => {
	const [sorted, setSorted] = useState([])
	const [filtered, setFiltered] = useState([])
	const [showFilters, setShowFilters] = useState(false)

	useEffect(() => {
		// Set to today by default on load
		let currentDates = {
			startDate: moment().startOf("day"),
			endDate: moment().endOf("day"),
		}
		props.updateDates(currentDates)
		props.getPayload()
	}, [])

	const columns = [
		{
			Header: "Subdivision",
			accessor: "subdivision",
			display: true,
			name: "Subdivision",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
		},
		{
			Header: "Section",
			accessor: "section",
			display: true,
			name: "Section",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
		{
			Header: "Acreage",
			accessor: "acreage",
			display: true,
			name: "Acreage",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "acreage"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.acreage
				})
				return numeral(total).format("0,0.00")
			},
		},
		{
			Header: "Platted Lots",
			accessor: "platted",
			display: true,
			name: "Platted Lots",
			filterMethod: (f, r) => helpers.tableText(f, r, "platted"),
			className: "right",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.platted
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "# of Homes Sold",
			accessor: "num_sold",
			display: true,
			name: "# of Homes Sold",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "num_sold"),
			Cell: (props) => numeral(props.value).format("0,0"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.num_sold
				})
				return numeral(total).format("0,0")
			},
		},
		{
			Header: "Total Sales Value",
			accessor: "num_sales_value",
			display: true,
			name: "Total Sales Value",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "num_sales_value"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.num_sales_value
				})
				return numeral(total).format("$0,0")
			},
		},
		{
			Header: "Average Sale Price",
			accessor: "avg_sale_price",
			display: true,
			name: "Average Sale Price",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "avg_sale_price"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableAverages(props, "avg_sale_price", "$0,0"),
		},
		{
			Header: "Occupied Completed Homes",
			accessor: "occupied",
			display: true,
			name: "Occupied Completed Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "occupied"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.occupied
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Unoccupied Completed Homes",
			accessor: "unoccupied",
			display: true,
			name: "Unoccupied Completed Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "unoccupied"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.unoccupied
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Current Models",
			accessor: "model",
			display: true,
			name: "Model Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "model"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.model
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Construction Not Under Contract",
			accessor: "construction_no_contract",
			display: true,
			name: "Construction Not Under Contract",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "construction_no_contract"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.construction_no_contract
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Construction Under Contract",
			accessor: "construction_contract",
			display: true,
			name: "Construction Under Contract",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "construction_contract"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.construction_contract
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Sold Homes Not Started",
			accessor: "sold_no_start",
			display: true,
			name: "Sold Homes Not Started",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "sold_no_start"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.sold_no_start
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Vacant Builder Lots",
			accessor: "vacant_builder_lots",
			display: true,
			name: "Vacant Builder Lots",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "vacant_builder_lots"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.vacant_builder_lots
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Vacant Developer Lots",
			accessor: "vacant_developer_lots",
			display: true,
			name: "Vacant Developer Lots",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "vacant_developer_lots"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.vacant_developer_lots
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Financing District FD",
			accessor: "mud",
			display: true,
			name: "Financing District FD",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "mud"),
		},
		{
			Header: "Community",
			accessor: "community",
			display: true,
			name: "Community",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "community"),
		},
		{
			Header: "Substantially Complete",
			accessor: "substantially_complete",
			display: true,
			name: "Substantially Complete",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "substantially_complete"),
		},
	]

	const builderColumns = [
		{
			Header: "Builder",
			accessor: "builder",
			display: true,
			name: "Builder",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Section",
			accessor: "section",
			display: true,
			name: "Section",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
		{
			Header: "Platted Lots",
			accessor: "platted",
			display: true,
			name: "Platted Lots",
			filterMethod: (f, r) => helpers.tableText(f, r, "platted"),
			className: "right",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.platted
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "# of Homes Sold",
			accessor: "num_sold",
			display: true,
			name: "# of Homes Sold",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "num_sold"),
			Cell: (props) => numeral(props.value).format("0,0"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.num_sold
				})
				return numeral(total).format("0,0")
			},
		},
		{
			Header: "Total Sales Value",
			accessor: "num_sales_value",
			display: true,
			name: "Total Sales Value",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "num_sales_value"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.num_sales_value
				})
				return numeral(total).format("$0,0")
			},
		},
		{
			Header: "Average Sale Price",
			accessor: "avg_sale_price",
			display: true,
			name: "Average Sale Price",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "avg_sale_price"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableAverages(props, "avg_sale_price", "$0,0"),
		},
		{
			Header: "Occupied Completed Homes",
			accessor: "occupied",
			display: true,
			name: "Occupied Completed Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "occupied"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.occupied
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Unoccupied Completed Homes",
			accessor: "unoccupied",
			display: true,
			name: "Unoccupied Completed Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "unoccupied"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.unoccupied
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Current Models",
			accessor: "model",
			display: true,
			name: "Model Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "model"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.model
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Construction Not Under Contract",
			accessor: "construction_no_contract",
			display: true,
			name: "Construction Not Under Contract",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "construction_no_contract"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.construction_no_contract
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Construction Under Contract",
			accessor: "construction_contract",
			display: true,
			name: "Construction Under Contract",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "construction_contract"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.construction_contract
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Sold Homes Not Started",
			accessor: "sold_no_start",
			display: true,
			name: "Sold Homes Not Started",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "sold_no_start"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.sold_no_start
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Vacant Builder Lots",
			accessor: "vacant_builder_lots",
			display: true,
			name: "Vacant Builder Lots",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "vacant_builder_lots"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.vacant_builder_lots
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Vacant Developer Lots",
			accessor: "vacant_developer_lots",
			display: true,
			name: "Vacant Developer Lots",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "vacant_developer_lots"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.vacant_developer_lots
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Financing District FD",
			accessor: "mud",
			display: true,
			name: "Financing District FD",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "mud"),
		},
		{
			Header: "Community",
			accessor: "community",
			display: true,
			name: "Community",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "community"),
		},
		{
			Header: "Substantially Complete",
			accessor: "substantially_complete",
			display: true,
			name: "Substantially Complete",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "substantially_complete"),
		},
	]

	const lotTypeColumns = [
		{
			Header: "Subdivision",
			accessor: "subdivision",
			display: true,
			name: "Subdivision",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
		},
		{
			Header: "Lot Type",
			accessor: "lot_type",
			display: true,
			name: "Lot Type",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "Platted Lots",
			accessor: "platted",
			display: true,
			name: "Platted Lots",
			filterMethod: (f, r) => helpers.tableText(f, r, "platted"),
			className: "right",
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.platted
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "# of Homes Sold",
			accessor: "num_sold",
			display: true,
			name: "# of Homes Sold",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "num_sold"),
			Cell: (props) => numeral(props.value).format("0,0"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.num_sold
				})
				return numeral(total).format("0,0")
			},
		},
		{
			Header: "Total Sales Value",
			accessor: "num_sales_value",
			display: true,
			name: "Total Sales Value",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "num_sales_value"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.num_sales_value
				})
				return numeral(total).format("$0,0")
			},
		},
		{
			Header: "Average Sale Price",
			accessor: "avg_sale_price",
			display: true,
			name: "Average Sale Price",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "avg_sale_price"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableAverages(props, "avg_sale_price", "$0,0"),
		},
		{
			Header: "Occupied Completed Homes",
			accessor: "occupied",
			display: true,
			name: "Occupied Completed Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "occupied"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.occupied
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Unoccupied Completed Homes",
			accessor: "unoccupied",
			display: true,
			name: "Unoccupied Completed Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "unoccupied"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.unoccupied
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Current Models",
			accessor: "model",
			display: true,
			name: "Model Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "model"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.model
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Construction Not Under Contract",
			accessor: "construction_no_contract",
			display: true,
			name: "Construction Not Under Contract",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "construction_no_contract"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.construction_no_contract
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Construction Under Contract",
			accessor: "construction_contract",
			display: true,
			name: "Construction Under Contract",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "construction_contract"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.construction_contract
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Sold Homes Not Started",
			accessor: "sold_no_start",
			display: true,
			name: "Sold Homes Not Started",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "sold_no_start"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.sold_no_start
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Vacant Builder Lots",
			accessor: "vacant_builder_lots",
			display: true,
			name: "Vacant Builder Lots",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "vacant_builder_lots"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.vacant_builder_lots
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Vacant Developer Lots",
			accessor: "vacant_developer_lots",
			display: true,
			name: "Vacant Developer Lots",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "vacant_developer_lots"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.vacant_developer_lots
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Financing District FD",
			accessor: "mud",
			display: true,
			name: "Financing District FD",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "mud"),
		},
		{
			Header: "Community",
			accessor: "community",
			display: true,
			name: "Community",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "community"),
		},
		{
			Header: "Substantially Complete",
			accessor: "substantially_complete",
			display: true,
			name: "Substantially Complete",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "substantially_complete"),
		},
	]

	const constructionColumns = [
		{
			Header: "MUD",
			accessor: "mud",
			display: true,
			name: "MUD",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "mud"),
		},
		{
			Header: "Builder",
			accessor: "builder",
			display: true,
			name: "Builder",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Lot Type",
			accessor: "lotType",
			display: true,
			name: "Lot Type",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "lotType"),
		},
		{
			Header: "Section",
			accessor: "section",
			display: true,
			name: "Section",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
		{
			Header: "Total Lots",
			accessor: "total_lots",
			display: true,
			name: "Total Lots",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "total_lots"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.total_lots
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Total Completed Homes",
			accessor: "total_completed",
			display: true,
			name: "Total Completed Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "total_completed"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.total_completed
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Completed Homes Occupied",
			accessor: "completed_occupied",
			display: true,
			name: "Completed Homes Occupied",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "completed_occupied"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.completed_occupied
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Completed Homes Unoccupied-Specs",
			accessor: "completed_unoccupied_specs",
			display: true,
			name: "Completed Homes Unoccupied-Specs",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "completed_unoccupied_specs"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.completed_unoccupied_specs
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Completed Homes Contracted Not Closed",
			accessor: "completed_contracted_not_closed",
			display: true,
			name: "Completed Homes Contracted Not Closed",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "completed_contracted_not_closed"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.completed_contracted_not_closed
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Model Homes",
			accessor: "model_homes",
			display: true,
			name: "Model Homes",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "model_homes"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.model_homes
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Total Completed Homes Unoccupied",
			accessor: "total_completed_unoccupied",
			display: true,
			name: "Total Completed Homes Unoccupied",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "total_completed_unoccupied"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.total_completed_unoccupied
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Homes Under Construction Under Contract",
			accessor: "homes_under_construction_contract",
			display: true,
			name: "Homes Under Construction Under Contract",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "homes_under_construction_contract"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.homes_under_construction_contract
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Homes Under Construction Without Contract-Specs",
			accessor: "homes_under_construction_specs",
			display: true,
			name: "Homes Under Construction Without Contract-Specs",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "homes_under_construction_specs"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.homes_under_construction_specs
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Total Homes Under Construction",
			accessor: "total_homes_under_construction",
			display: true,
			name: "Total Homes Under Construction",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "total_homes_under_construction"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.total_homes_under_construction
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Vacant Lots",
			accessor: "vacant_lots",
			display: true,
			name: "Vacant Lots",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "vacant_lots"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.vacant_lots
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
		{
			Header: "Completed + Homes Under Construction",
			accessor: "completed_plus_construction",
			display: true,
			name: "Completed + Homes Under Construction",
			className: "right",
			filterMethod: (f, r) => helpers.tableText(f, r, "completed_plus_construction"),
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					total += v.completed_plus_construction
				})
				if (typeof total == "number") {
					return total.toLocaleString()
				}
				return total
			},
		},
	]

	const supply = () => {
		let ret = []
		let store = {}
		let date = props.currentDates.startStamp
		_.forEach(props.payload.exec.lots, (v) => {
			let model = {
				platted: 0,
				occupied: 0,
				num_sold: 0,
				num_sales_value: 0,
				unoccupied: 0,
				model: 0,
				construction_no_contract: 0,
				construction_contract: 0,
				sold_no_start: 0,
				vacant_builder_lots: 0,
				vacant_developer_lots: 0,
				mud: "",
				acreage: 0,
				substantially_complete: "",
			}
			let community = _.find(props.payload.public.properties, { id: v.property })
			if (!community) {
				console.log("no community", v)
				return
			}
			let sub = _.find(props.payload.public.subdivisions, { id: v.subdivision })
			if (!sub) {
				console.log("no sub", v)
				return
			}
			let section = _.find(props.payload.public.sections, { id: v.section_id })
			if (!section) {
				return
			}
			let mud = _.find(props.payload.public.muds, { id: v.mud })
			if (!mud) {
				console.log("no mud", v)
				return
			}
			let path = `${community.name}.${sub.name}.${section.name}.${mud.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, model, Object)
			}

			store[community.name][sub.name][section.name][mud.name].platted++
			if (v.sale_date && v.sale_date < date) {
				store[community.name][sub.name][section.name][mud.name].num_sold++ // this is safe i think to leave in this block because you dont want cancels or transfer adding into this number.
				//old
				//store[community.name][sub.name][section.name][mud.name].num_sales_value += v.sale_price
				//? Advanced logic - it figures out the difference in days between the start date and complete date, determines the price per day based on the sale price, and figures out the value of that lot based on the selected date.
				let start = v.start_date ? moment.unix(v.start_date) : moment()
				let complete = v.complete_date ? moment.unix(v.complete_date) : moment()
				if(complete.unix() > date) complete = moment.unix(date)
				let days = complete.diff(start, "days")
				let perDay
				if (v.start_date && v.complete_date && v.start_date !== v.complete_date) {
					perDay = v.sale_price / days
				} else {
					// Figure out an estimate based on a 205 day build time.  205 days is the average build time as of 4/11/24.
					perDay = v.sale_price / 205
				}
				if (!_.isFinite(perDay)) perDay = 0
				let value
				if (days) {
					value = perDay * days
				} else {
					// fall back to just use the full sale price.  better than crashing the averags.
					value = v.sale_price || 0
				}
				//if(!value) console.log(v, days, perDay)
				store[community.name][sub.name][section.name][mud.name].num_sales_value += value
			}
			if (v.closing_date && v.closing_date < date) {
				store[community.name][sub.name][section.name][mud.name].occupied++
			}
			//if (!v.closing_date && v.complete_date) {
			if ((!v.closing_date || v.closing_date > date) && v.complete_date && v.complete_date < date) {
				store[community.name][sub.name][section.name][mud.name].unoccupied++
			}
			if (v.model) {
				store[community.name][sub.name][section.name][mud.name].model++
			}
			if (!v.complete_date && !v.sale_id && !v.model && v.start_date) {
				store[community.name][sub.name][section.name][mud.name].construction_no_contract++
			}
			if (!v.complete_date && v.sale_id && !v.model && v.start_date) {
				store[community.name][sub.name][section.name][mud.name].construction_contract++
			}
			if (v.sale_id && !v.start_date && !v.model) {
				store[community.name][sub.name][section.name][mud.name].sold_no_start++
			}
			if (!v.start_date && v.takedown_date && v.builder && !v.model) {
				store[community.name][sub.name][section.name][mud.name].vacant_builder_lots++
			}
			if (!v.takedown_date && !v.model) {
				store[community.name][sub.name][section.name][mud.name].vacant_developer_lots++
			}

			//v = helpers.translateObject(v, translate)
			store[community.name][sub.name][section.name][mud.name].mud = mud.name
			store[community.name][sub.name][section.name][mud.name].acreage = section.acreage
			store[community.name][sub.name][section.name][mud.name].substantially_complete =
				section.substantially_complete ? "Yes" : "No"
		})
		console.log(store)
		_.forEach(store, (row, property) => {
			_.forEach(row, (row, sub) => {
				_.forEach(row, (row, section) => {
					_.forEach(row, (row, mud) => {
						let avg_sale_price = numeral(row.num_sales_value / row.num_sold).format("0,0.00")
						avg_sale_price = numeral(avg_sale_price).value()
						ret.push({
							subdivision: sub,
							section: section,
							platted: row.platted,
							avg_sale_price,
							occupied: row.occupied,
							unoccupied: row.unoccupied,
							model: row.model,
							construction_no_contract: row.construction_no_contract,
							construction_contract: row.construction_contract,
							sold_no_start: row.sold_no_start,
							vacant_builder_lots: row.vacant_builder_lots,
							vacant_developer_lots: row.vacant_developer_lots,
							mud: mud,
							community: property,
							substantially_complete: row.substantially_complete,
							num_sold: row.num_sold,
							num_sales_value: row.num_sales_value,
							acreage: row.acreage,
						})
					})
				})
			})
		})
		return ret
	}

	const builderSupply = () => {
		let ret = []
		let store = {}
		let date = props.currentDates.startStamp
		_.forEach(props.payload.exec.lots, (v) => {
			let model = {
				platted: 0,
				occupied: 0,
				num_sold: 0,
				num_sales_value: 0,
				unoccupied: 0,
				model: 0,
				construction_no_contract: 0,
				construction_contract: 0,
				sold_no_start: 0,
				vacant_builder_lots: 0,
				vacant_developer_lots: 0,
				mud: "",
				substantially_complete: "",
			}
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			if (!builder) {
				return
			}
			let community = _.find(props.payload.public.properties, { id: v.property })
			if (!community) {
				return
			}
			let section = _.find(props.payload.public.sections, { id: v.section_id })
			if (!section) {
				return
			}
			let mud = _.find(props.payload.public.muds, { id: v.mud })
			if (!mud) {
				return
			}
			builder.name = helpers.safeBuilderName(builder.name)
			let path = `${community.name}.${builder.name}.${section.name}.${mud.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, model, Object)
			}
			store[community.name][builder.name][section.name][mud.name].platted++
			if (v.sale_date && v.sale_date < date) {
				store[community.name][builder.name][section.name][mud.name].num_sold++
				//? Advanced logic - it figures out the difference in days between the start date and complete date, determines the price per day based on the sale price, and figures out the value of that lot based on the selected date.
				let start = v.start_date ? moment.unix(v.start_date) : moment()
				let complete = v.complete_date ? moment.unix(v.complete_date) : moment()
				if (complete.unix() > date) complete = moment.unix(date)
				let days = complete.diff(start, "days")
				let perDay
				if (v.start_date && v.complete_date && v.start_date !== v.complete_date) {
					perDay = v.sale_price / days
				} else {
					// Figure out an estimate based on a 205 day build time.  205 days is the average build time as of 4/11/24.
					perDay = v.sale_price / 205
				}
				if (!_.isFinite(perDay)) perDay = 0
				let value
				if (days) {
					value = perDay * days
				} else {
					// fall back to just use the full sale price.  better than crashing the averags.
					value = v.sale_price || 0
				}
				//if(!value) console.log(v, days, perDay)
				store[community.name][builder.name][section.name][mud.name].num_sales_value += value
			}
			if (v.closing_date && v.closing_date < date) {
				store[community.name][builder.name][section.name][mud.name].occupied++
			}
			//if (!v.closing_date && v.complete_date) {
			if ((!v.closing_date || v.closing_date > date) && v.complete_date && v.complete_date < date) {
				store[community.name][builder.name][section.name][mud.name].unoccupied++
			}
			if (v.model) {
				store[community.name][builder.name][section.name][mud.name].model++
			}
			if (!v.complete_date && !v.sale_id && !v.model && v.start_date) {
				store[community.name][builder.name][section.name][mud.name].construction_no_contract++
			}
			if (!v.complete_date && v.sale_id && !v.model && v.start_date) {
				store[community.name][builder.name][section.name][mud.name].construction_contract++
			}
			if (v.sale_id && !v.start_date && !v.model) {
				store[community.name][builder.name][section.name][mud.name].sold_no_start++
			}
			if (!v.start_date && v.takedown_date && v.builder && !v.model) {
				store[community.name][builder.name][section.name][mud.name].vacant_builder_lots++
			}
			if (!v.takedown_date && !v.model) {
				store[community.name][builder.name][section.name][mud.name].vacant_developer_lots++
			}

			//v = helpers.translateObject(v, translate)
			store[community.name][builder.name][section.name][mud.name].mud = mud.name
			store[community.name][builder.name][section.name][mud.name].acreage = section.acreage
			store[community.name][builder.name][section.name][mud.name].substantially_complete =
				section.substantially_complete ? "Yes" : "No"
		})
		_.forEach(store, (row, property) => {
			_.forEach(row, (row, builder) => {
				_.forEach(row, (row, section) => {
					_.forEach(row, (row, mud) => {
						let avg_sale_price = numeral(row.num_sales_value / row.num_sold).format("0,0.00")
						avg_sale_price = numeral(avg_sale_price).value()
						ret.push({
							builder: builder,
							section: section,
							platted: row.platted,
							occupied: row.occupied,
							unoccupied: row.unoccupied,
							model: row.model,
							construction_no_contract: row.construction_no_contract,
							construction_contract: row.construction_contract,
							sold_no_start: row.sold_no_start,
							vacant_builder_lots: row.vacant_builder_lots,
							vacant_developer_lots: row.vacant_developer_lots,
							mud: mud,
							community: property,
							substantially_complete: row.substantially_complete,
							num_sold: row.num_sold,
							num_sales_value: row.num_sales_value,
							avg_sale_price,
						})
					})
				})
			})
		})
		return ret
	}

	const lotTypeSupply = () => {
		let ret = []
		let store = {}
		let date = props.currentDates.startStamp
		_.forEach(props.payload.exec.lots, (v) => {
			let model = {
				platted: 0,
				occupied: 0,
				num_sold: 0,
				num_sales_value: 0,
				unoccupied: 0,
				model: 0,
				construction_no_contract: 0,
				construction_contract: 0,
				sold_no_start: 0,
				vacant_builder_lots: 0,
				vacant_developer_lots: 0,
				mud: "",
				acreage: 0,
				substantially_complete: "",
			}
			let community = _.find(props.payload.public.properties, { id: v.property })
			if (!community) {
				console.log("no community", v)
				return
			}
			let sub = _.find(props.payload.public.subdivisions, { id: v.subdivision })
			if (!sub) {
				console.log("no sub", v)
				return
			}
			let lt = _.find(props.payload.public.lot_types, { id: v.lot_type })
			if (!lt) {
				return
			}
			let mud = _.find(props.payload.public.muds, { id: v.mud })
			if (!mud) {
				console.log("no mud", v)
				return
			}
			let path = `${community.name}.${sub.name}.${lt.name}.${mud.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, model, Object)
			}

			store[community.name][sub.name][lt.name][mud.name].platted++
			if (v.sale_date && v.sale_date < date) {
				store[community.name][sub.name][lt.name][mud.name].num_sold++ // this is safe i think to leave in this block because you dont want cancels or transfer adding into this number.
				//old
				//store[community.name][sub.name][lt.name][mud.name].num_sales_value += v.sale_price
				//? Advanced logic - it figures out the difference in days between the start date and complete date, determines the price per day based on the sale price, and figures out the value of that lot based on the selected date.
				let start = v.start_date ? moment.unix(v.start_date) : moment()
				let complete = v.complete_date ? moment.unix(v.complete_date) : moment()
				if (complete.unix() > date) complete = moment.unix(date)
				let days = complete.diff(start, "days")
				let perDay
				if (v.start_date && v.complete_date && v.start_date !== v.complete_date) {
					perDay = v.sale_price / days
				} else {
					// Figure out an estimate based on a 205 day build time.  205 days is the average build time as of 4/11/24.
					perDay = v.sale_price / 205
				}
				if (!_.isFinite(perDay)) perDay = 0
				let value
				if (days) {
					value = perDay * days
				} else {
					// fall back to just use the full sale price.  better than crashing the averags.
					value = v.sale_price || 0
				}
				//if(!value) console.log(v, days, perDay)
				store[community.name][sub.name][lt.name][mud.name].num_sales_value += value
			}
			if (v.closing_date && v.closing_date < date) {
				store[community.name][sub.name][lt.name][mud.name].occupied++
			}
			//if (!v.closing_date && v.complete_date) {
			if ((!v.closing_date || v.closing_date > date) && v.complete_date && v.complete_date < date) {
				store[community.name][sub.name][lt.name][mud.name].unoccupied++
			}
			if (v.model) {
				store[community.name][sub.name][lt.name][mud.name].model++
			}
			if (!v.complete_date && !v.sale_id && !v.model && v.start_date) {
				store[community.name][sub.name][lt.name][mud.name].construction_no_contract++
			}
			if (!v.complete_date && v.sale_id && !v.model && v.start_date) {
				store[community.name][sub.name][lt.name][mud.name].construction_contract++
			}
			if (v.sale_id && !v.start_date && !v.model) {
				store[community.name][sub.name][lt.name][mud.name].sold_no_start++
			}
			if (!v.start_date && v.takedown_date && v.builder && !v.model) {
				store[community.name][sub.name][lt.name][mud.name].vacant_builder_lots++
			}
			if (!v.takedown_date && !v.model) {
				store[community.name][sub.name][lt.name][mud.name].vacant_developer_lots++
			}

			//v = helpers.translateObject(v, translate)
			store[community.name][sub.name][lt.name][mud.name].mud = mud.name
		})
		_.forEach(store, (row, property) => {
			_.forEach(row, (row, sub) => {
				_.forEach(row, (row, lt) => {
					_.forEach(row, (row, mud) => {
						let avg_sale_price = numeral(row.num_sales_value / row.num_sold).format("0,0.00")
						avg_sale_price = numeral(avg_sale_price).value()
						ret.push({
							subdivision: sub,
							lot_type: lt,
							platted: row.platted,
							avg_sale_price,
							occupied: row.occupied,
							unoccupied: row.unoccupied,
							model: row.model,
							construction_no_contract: row.construction_no_contract,
							construction_contract: row.construction_contract,
							sold_no_start: row.sold_no_start,
							vacant_builder_lots: row.vacant_builder_lots,
							vacant_developer_lots: row.vacant_developer_lots,
							mud: mud,
							community: property,
							substantially_complete: row.substantially_complete,
							num_sold: row.num_sold,
							num_sales_value: row.num_sales_value,
							acreage: row.acreage,
						})
					})
				})
			})
		})
		return ret
	}

	const constructionSupply = () => {
		let ret = []
		let store = {}
		let date = props.currentDates.startStamp
		_.forEach(props.payload.exec.lots, (v) => {
			let model = {
				total_lots: 0,
				total_completed: 0,
				completed_occupied: 0,
				completed_unoccupied_specs: 0,
				completed_contracted_not_closed: 0,
				model_homes: 0,
				total_completed_unoccupied: 0,
				homes_under_construction_contract: 0,
				homes_under_construction_specs: 0,
				total_homes_under_construction: 0,
				vacant_lots: 0,
				completed_plus_construction: 0,
			}
			let mud = _.find(props.payload.public.muds, { id: v.mud })
			if (!mud) {
				return
			}
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			if (!builder) {
				return
			}
			let lotType = _.find(props.payload.public.lot_types, { id: v.lot_type })
			if (!lotType) {
				return
			}
			let section = _.find(props.payload.public.sections, { id: v.section_id })
			if (!section) {
				return
			}
			builder.name = helpers.safeBuilderName(builder.name)
			let path = `${mud.name}.${builder.name}.${lotType.name}.${section.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, model, Object)
			}

			// Total Lots
			store[mud.name][builder.name][lotType.name][section.name].total_lots++

			// Total Completed Homes (construction complete)
			if (v.complete_date && v.complete_date < date) {
				store[mud.name][builder.name][lotType.name][section.name].total_completed++
				store[mud.name][builder.name][lotType.name][section.name].completed_plus_construction++

				// Completed Homes Occupied (closed)
				if (v.closing_date && v.closing_date < date) {
					store[mud.name][builder.name][lotType.name][section.name].completed_occupied++
				}

				// Completed Homes Unoccupied-SPECS (comp/spec)
				if ((!v.closing_date || v.closing_date > date) && !v.model && !v.sale_id) {
					store[mud.name][builder.name][lotType.name][section.name].completed_unoccupied_specs++
				}

				// Completed Homes Contracted not Closed
				if ((!v.closing_date || v.closing_date > date) && v.sale_id && !v.model) {
					store[mud.name][builder.name][lotType.name][section.name].completed_contracted_not_closed++
				}

				// Model Homes
				if (v.model) {
					store[mud.name][builder.name][lotType.name][section.name].model_homes++
				}
			}

			// Total Completed Homes Unoccupied
			if (v.complete_date && v.complete_date < date && (!v.closing_date || v.closing_date > date)) {
				store[mud.name][builder.name][lotType.name][section.name].total_completed_unoccupied++
			}

			// Homes Under Construction
			if (v.start_date && v.start_date < date && (!v.complete_date || v.complete_date > date)) {
				store[mud.name][builder.name][lotType.name][section.name].completed_plus_construction++
				store[mud.name][builder.name][lotType.name][section.name].total_homes_under_construction++

				// Under contract to home buyer
				if (v.sale_id && !v.model) {
					store[mud.name][builder.name][lotType.name][section.name].homes_under_construction_contract++
				}

				// Without contract-SPECS
				if (!v.sale_id && !v.model) {
					store[mud.name][builder.name][lotType.name][section.name].homes_under_construction_specs++
				}
			}

			// Vacant Lots
			if (!v.start_date && !v.model) {
				store[mud.name][builder.name][lotType.name][section.name].vacant_lots++
			}
		})

		_.forEach(store, (row, mud) => {
			_.forEach(row, (row, builder) => {
				_.forEach(row, (row, lotType) => {
					_.forEach(row, (row, section) => {
						ret.push({
							mud: mud,
							builder: builder,
							lotType: lotType,
							section: section,
							total_lots: row.total_lots,
							total_completed: row.total_completed,
							completed_occupied: row.completed_occupied,
							completed_unoccupied_specs: row.completed_unoccupied_specs,
							completed_contracted_not_closed: row.completed_contracted_not_closed,
							model_homes: row.model_homes,
							total_completed_unoccupied: row.total_completed_unoccupied,
							homes_under_construction_contract: row.homes_under_construction_contract,
							homes_under_construction_specs: row.homes_under_construction_specs,
							total_homes_under_construction: row.total_homes_under_construction,
							vacant_lots: row.vacant_lots,
							completed_plus_construction: row.completed_plus_construction,
						})
					})
				})
			})
		})
		return ret
	}

	if (props.payloadStatus) {
		let appendedText = [
			{
				text: "Please note that there are overlaps in these two categories:",
				style: "smallText",
				margin: [0, 15, 0, 5],
			},
			{
				bold: true,
				style: "smallText",
				ol: [
					`"Model Homes" are also counted under "Unoccupied Completed Homes". If a model home has been purchased and closed to a homebuyer, and leased back to the builder for continued use as a model, then that model home will be counted under "Occupied Completed Homes" since it is no longer a sales opportunity.`,
					`"Sold Homes, Not Started" are also counted under "Vacant Builder Lots" and "Vacant Developer Lots". Builder Lots have been taken down by the Builders, and Developer Lots may be assigned to builders but have not yet been taken down.`,
				],
			},
		]
		return (
			<div className="inventory">
				<div className="imageGroup">
					<Title title="MUD Report" custom={true} />
					<div className="content inventory__content">
						<p className="mid infoNote">
							<i className={`fas fa-info-circle`} />
							For total sales value, the report takes into consideration the construction status of a lot
							when determining value. For example, if today's date is selected and a dirt sale happened a
							month ago, the value of that lot is prorated as of today, not the total sale price for the
							contract upon completion. If a completed spec sold last year, the full contract price would
							be counted.
						</p>
						<FullTable
							data={supply()}
							columns={columns}
							name="mud"
							title="MUD"
							appendedText={appendedText}
							classNames={"small"}
							pageSize={20}
						/>
						<h2>With Builder</h2>
						<FullTable
							data={builderSupply()}
							columns={builderColumns}
							name="mud__builder"
							title="MUD Builder"
							appendedText={appendedText}
							classNames={"small"}
							pageSize={20}
						/>

						<h2>By Lot Type</h2>
						<FullTable
							data={lotTypeSupply()}
							columns={lotTypeColumns}
							name="mud__lotType"
							title="MUD Lot Type"
							appendedText={appendedText}
							classNames={"small"}
							pageSize={20}
						/>

						<h2>Construction Report</h2>
						<FullTable
							data={constructionSupply()}
							columns={constructionColumns}
							name="mud__construction"
							title="Construction Report"
							appendedText={appendedText}
							classNames={"small"}
							pageSize={20}
						/>

						<p className="mid">Please note that there are overlaps in these two categories:</p>
						<ol className="mid">
							<li>
								"Model Homes" are also counted under "Unoccupied Completed Homes". If a model home has
								been purchased and closed to a homebuyer, and leased back to the builder for continued
								use as a model, then that model home will be counted under "Occupied Completed Homes"
								since it is no longer a sales opportunity.
							</li>
							<li>
								"Sold Homes, Not Started" are also counted under "Vacant Builder Lots" and "Vacant
								Developer Lots". Builder Lots have been taken down by the Builders, and Developer Lots
								may be assigned to builders but have not yet been taken down.
							</li>
						</ol>
					</div>
				</div>
			</div>
		)
	} else {
		return ""
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			updateDates,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(MUD)
